export default __webpack_public_path__ + "static/sky-logo.img-cb7ba7b9fd839b037e9b44036cbd64aa.svg";